/* ═══════════════════════════════════════════════════════════
   GREENTEX SHOPIFY THEME — 共通 JS
   ─────────────────────────────────────────────────────────
   - cart badge 更新
   - search 開閉トグル
   - ESC キーで閉じる
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ─── SEARCH: トグル ───────────────────────────────────
  window.toggleSearch = function() {
    var wrap = document.getElementById('searchWrap');
    if (!wrap) return;
    var input = document.getElementById('searchInput');
    var isOpen = wrap.classList.toggle('open');
    if (isOpen && input) {
      input.focus();
    } else if (input) {
      input.value = '';
    }
  };

  // ─── ESC で検索閉じる ─────────────────────────────────
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var wrap = document.getElementById('searchWrap');
      if (wrap) wrap.classList.remove('open');
      var input = document.getElementById('searchInput');
      if (input) input.value = '';
    }
  });

  // ─── CART BADGE: Shopify cart からリアルタイム取得 ───
  // theme.liquid で {{ cart.item_count }} 既に出してるが、
  // AJAX 追加後のリアクティブ更新用に fetch /cart.js
  window.updateCartBadge = function() {
    var badge = document.getElementById('cartBadge');
    if (!badge) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }})
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        badge.textContent = cart.item_count;
        badge.classList.toggle('visible', cart.item_count > 0);
      })
      .catch(function() { /* silent */ });
  };

  // 初回チェック（cart 変更後のページ遷移時）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.updateCartBadge);
  } else {
    window.updateCartBadge();
  }

})();
